import type { FC } from 'react';
import React from 'react';
import { Edit as EditPage } from '../Edit';

export const Create: FC = () => (
  <div>
    <EditPage />
  </div>
);
